import { NzMessageService } from 'ng-zorro-antd/message';
import { Component, Input, Output, EventEmitter, OnChanges, ViewChild, ElementRef } from '@angular/core';
import { ConfirmationService} from '@services/sys/confirmation.service';

@Component({
    selector: 'app-z-url',
    templateUrl: './z-url.component.html',
    styleUrl: './z-url.component.less'
})
export class ZUrlComponent implements OnChanges {
    @ViewChild('editorTextArea') editorTextArea!: ElementRef;
    @Input() initialValue: string = '';  // 父组件传递的初始值
    @Input() placeholder = 'Add a link ...';
    @Input() required = false;
    @Input() rows = 1;
    @Input() saveLoading = false;
    @Input() inactiveUsers: boolean = false;
    @Output() valueSaved = new EventEmitter<string>();  // 父组件监听保存事件
    @Output() focusEvent = new EventEmitter<void>();
    @Output() blurEvent = new EventEmitter<void>();

    isHovered = false;
    isEditing = false;
    currentValue: string = this.initialValue;  // 当前显示的值
    inputValue: string = this.currentValue;    // 输入框中的值

    constructor(private message: NzMessageService,
                private confirmationService: ConfirmationService) {
    }

    ngOnChanges(): void {
        this.currentValue = this.initialValue;  // 当输入的值发生变化时，更新显示值
        this.inputValue = this.currentValue;
    }

    onMouseEnter(): void {
        if (!this.isEditing) {
            this.isHovered = true;
        }
    }

    onMouseLeave(): void {
        this.isHovered = false;
    }

    startEditing(): void {
        console.log('startEditing');
        this.isEditing = true;
        this.isHovered = false;  // 进入编辑状态时去除背景色
        setTimeout(() => {
            if (this.editorTextArea) {
                this.editorTextArea.nativeElement.focus();
            }
            this.focusEvent.emit(); // Emit focus event
        });
    }

    onBlur(): void {
        console.log('onBlur');
        let inputValue = this.inputValue;

        if (this.required && !(inputValue || inputValue.toString() === '0')) {
            this.message.error('This field is required');
            this.inputValue = this.currentValue;  // 恢复成之前的值
            return;
        }

        if (inputValue != null && inputValue !== '') {
            inputValue = inputValue.trim();
        }

        this.confirmationService.confirmUpdateTask(this.inactiveUsers, () => {
            this.isEditing = false;
            // Emit blur event
            this.blurEvent.emit();
            // url 验证：必须包含一个点，且点后面必须有字母且不能为空
            if (inputValue) {
                const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9.-]+|(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))(:[0-9]+)?(\/.*)?$/;

                if (!urlPattern.test(inputValue)) {
                    this.message.error('Please enter a valid URL address');
                    this.inputValue = this.currentValue;
                    return;
                }

                let hostPart = inputValue.replace(/^(https?:\/\/)?/, '').split(/[\/?#]/)[0];

                const hostWithoutPort = hostPart.split(':')[0];

                const isIP = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(hostWithoutPort);
                const isLocalhost = hostWithoutPort === 'localhost';
                const isDomain = hostWithoutPort.includes('.') && /[a-zA-Z]/.test(hostWithoutPort.split('.').pop() || '');

                if (!isIP && !isLocalhost && !isDomain) {
                    this.message.error('Please enter a valid URL address');
                    this.inputValue = this.currentValue;
                    return;
                }
            }
            this.currentValue = this.inputValue;  // 保存新值
            this.valueSaved.emit(this.currentValue);  // 触发保存事件
        }, () => { this.handleCancel(); });
        // 没有改变
        if (inputValue === this.currentValue) {
            return;
        }
    }

    // 阻止回车换行
    onKeydown(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            event.preventDefault();  // 阻止默认的回车换行行为
        }
    }

    handleCancel(): void {
        this.inputValue = this.currentValue;  // 恢复成之前的值
        this.isEditing = false;
        console.log('cancel', this.isEditing);
    }

    goTo(): string {
        if (this.currentValue.startsWith('http')) {
            return this.currentValue;
        }
        else {
            return 'http://' + this.currentValue;
        }
    }
}

